import { GridRow } from 'app/layouts/grid';
import { Button } from 'app/shared/button';
import { BasicInfoSection } from 'app/shared/info-section/basic';
import { DetailItem } from 'app/shared/info-section/item';
import { SimpleInput } from 'app/shared/input';
import { TextArea } from 'app/shared/input/textarea';
import useValidator from 'hooks/validator';
import React, { useContext, useEffect, useState } from 'react';
import { RoleValidationSchema } from '../schema';
import { PermissionsContext } from 'contexts/permissions';
import { useSubscriptionService } from 'hooks/sales/subscription';
import { useRoleService } from 'hooks/iam/role';

export const RoleBasicInformation = ({
  data = {},
  is_saving = false,
  onDataChange = () => {},
  onSave = () => {}
}) => {
  const { fetchRoles } = useRoleService();
  const { determineSubscriptionPlanClass } = useSubscriptionService();
  const { errors, validateField, form_is_valid } = useValidator(RoleValidationSchema);
  const { permissions } = useContext(PermissionsContext);

  const [can_create_role, setCanCreateRole] = useState(false);

  useEffect(() => {
    Promise.all([
      determineSubscriptionPlanClass({
        query_string:
          'plan_code=campaign,startup,automation,mobi_push, web_push,automation_plus&status=active'
      }),
      fetchRoles({ query_string: 'type=user' })
    ]).then(([plan_class, { roles }]) => {
      let can_create = plan_class === 'enterprise';
      if (plan_class === 'growth' && roles.length < 3) can_create = true;
      setCanCreateRole(can_create);
    });
  }, []);

  useEffect(() => {
    if (!data) return;
    Object.keys(data).forEach((key) => {
      validateField(key, data[key]);
    });
  }, [data]);

  return (
    <BasicInfoSection title="Basic Details">
      <div>
        <GridRow num_of_columns={1}>
          <DetailItem title="Name">
            <SimpleInput
              error={errors.name}
              value={data.name}
              onInput={(value) => onDataChange('name', value)}
            />
          </DetailItem>
        </GridRow>
        <GridRow num_of_columns={1}>
          <DetailItem title="Description">
            <TextArea
              error={errors.description}
              value={data.description}
              onInput={(value) => onDataChange('description', value)}
            />
          </DetailItem>
        </GridRow>
        <GridRow num_of_columns={1}>
          <Button
            text="Save Changes"
            onClick={onSave}
            disabled={
              !form_is_valid ||
              is_saving ||
              !permissions['user_management:update'] ||
              !can_create_role
            }
          />
        </GridRow>
      </div>
    </BasicInfoSection>
  );
};
